import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import "./Calculators.css"
import { Pagination, Stack } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from "../../data/notification";
import { Search, ThreeDotsVertical, Plus } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import AddCity from './AddCity';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from '../../i18n/useT';

const Calculators = () => {
    const [filter, setFilter] = useState({limit: 10, page: 1, keyword: "", auction: "", port: ""});
    const [calculators, setCalculators] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const [showCalculatorsModal, setShowCalculatorsModal] = useState(false);
    const [formData, setFormData] = useState({auction: "", city: "", destination: "", land_price: "", container_price: "", total_price: "", port: ""})
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [createdCalculatorsCount, setCreatedCalculatorsCount] = useState(0);
    const [loadingCreateCalculators, setLoadingCreateCalculators] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [actionsId, setActionsId] = useState("");
    const [actionType, setActionType] = useState("add");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [priceForm, setPriceForm] = useState({amount: "", type: "", port: "", action: "", show: false});
    const {view, setView, isMobile} = useViewMode("calculator-view");
    const t = useT();

    const rowActions = (calc) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(calc.id)} style={{cursor: "pointer"}}/>
            {actionsId === calc.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setFormData({...calc});
                        setShowCalculatorsModal(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData({...calc});
                        setShowConfirmationModal(true);
                    }}>{t("common.delete")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("calculator.city"), value: (calc) => calc.city},
        {label: t("calculator.destination"), value: (calc) => calc.destination},
        {label: t("calculator.landPrice"), value: (calc) => calc.land_price},
        {label: t("calculator.containerPrice"), value: (calc) => calc.container_price},
        {label: t("calculator.total"), value: (calc) => `${calc.total_price}$`},
        {label: t("calculator.port"), value: (calc) => calc.port},
    ];

    const handlers = {
        createCalculators(e){
            e.preventDefault();
            setLoadingCreateCalculators(true);
            axios.post('/api/calculator', formData)
                .then((res) => {
                    setShowCalculatorsModal(false);
                    setLoadingCreateCalculators(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedCalculatorsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateCalculators(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyCalculators(e){
            e.preventDefault();
            setLoadingCreateCalculators(true);
            axios.put(`/api/calculator/${formData.id}`, formData)
                .then((res) => {
                    setLoadingCreateCalculators(false);
                    setShowCalculatorsModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedCalculatorsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateCalculators(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        deleteCalculators(){
            setLoadingCreateCalculators(true);
            axios.delete(`/api/users/${formData.id}`)
                .then((res) => {
                    setLoadingCreateCalculators(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedCalculatorsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateCalculators(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        changePriceByPort(e){
            setLoadingCreateCalculators(true);
            e.preventDefault();
            axios.put('/api/calculator-by-port', priceForm)
                .then((res) => {
                    setLoadingCreateCalculators(false);
                    setPriceForm((prev) => ({...prev, show: false}));
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedCalculatorsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateCalculators(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/calculator?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&auction=${filter.auction}&port=${filter.port}`)
            .then((res) => {
                setLoading(false);
                setCalculators(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter, createdCalculatorsCount]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("calculator.title")}</h2>
            <div className="table-filter-container">
                <button className='btn btn-primary' onClick={() => {
                    setPriceForm({amount: "", type: "", port: "", action: "", show: true});
                }} style={{display: "flex", alignItems: "center", marginRight: "15px"}} >{t("calculator.priceByPort")}</button>
                <button className='btn btn-primary' style={{display: "flex", alignItems: "center", marginRight: "15px"}} onClick={() => {
                    setShowCalculatorsModal(true);
                    setFormData({auction: "", city: "", destination: "", land_price: "", container_price: "", total_price: "", port: ""});
                    setActionType("add");
                }}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></button>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>{t("calculator.auction")}</th>
                        <th>{t("calculator.city")}</th>
                        <th>{t("calculator.destination")}</th>
                        <th>{t("calculator.landPrice")}</th>
                        <th>{t("calculator.containerPrice")}</th>
                        <th>{t("calculator.total")}</th>
                        <th>{t("calculator.port")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={8}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (calculators.length > 0 && !loading) && calculators.map((calc) => {
                            return(
                                <tr key={calc.id}>
                                    <td>{calc.auction}</td>
                                    <td>{calc.city}</td>
                                    <td>{calc.destination}</td>
                                    <td>{calc.land_price}</td>
                                    <td>{calc.container_price}</td>
                                    <td>{calc.total_price}$</td>
                                    <td>{calc.port}</td>
                                    <td>{rowActions(calc)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && calculators.length === 0) && <tr><td colSpan={8} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : calculators}
                    loading={loading}
                    getKey={(calc) => calc.id}
                    renderTitle={(calc) => calc.auction}
                    renderSubtitle={(calc) => calc.city}
                    fields={cardFields}
                    renderActions={(calc) => rowActions(calc)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <AddCity show={showCalculatorsModal} setShow={setShowCalculatorsModal} formData={formData} setFormData={setFormData} submit={actionType == "add" ? handlers.createCalculators : handlers.modifyCalculators} loading={loadingCreateCalculators} type={actionType} />
            <Modal show={priceForm.show} onHide={() => setPriceForm((prev) => ({...prev, show: false}))}>
                <Modal.Header closeButton><h3>{t("calculator.updatePrice")}</h3></Modal.Header>
                <Modal.Body>
                    <form onSubmit={handlers.changePriceByPort}>
                        <div className='form-group mt-4'>
                            <label>{t("calculator.amount")}</label>
                            <input type='number' className='form-control' value={priceForm.amount} onChange={(e) => setPriceForm((prev) => ({...prev, amount: e.target.value}))} />
                        </div>
                        <div className='form-group mt-4'>
                            <label>{t("calculator.type")}</label>
                            <select className='form-control' value={priceForm.type} onChange={(e) => setPriceForm((prev) => ({...prev, type: e.target.value}))}>
                                <option value="">{t("calculator.selectType")}</option>
                                <option value="land">{t("calculator.land")}</option>
                                <option value="container">{t("calculator.container")}</option>
                            </select>
                        </div>
                        <div className='form-group mt-4'>
                            <label>{t("calculator.port")}</label>
                            <select name="port" className='form-control' required value={priceForm.port} onChange={(e) => setPriceForm((prev) => ({...prev, port: e.target.value}))}>
                                <option value={"(პორტი Washington)"}>{t("calculator.portWA")}</option>
                                <option value={"(პორტი California)"}>{t("calculator.portCA")}</option>
                                <option value={"(პორტი Texas)"}>{t("calculator.portTX")}</option>
                                <option value={"(პორტი Georgia)"}>{t("calculator.portGA")}</option>
                                <option value={"(პორტი Seatle)"}>{t("calculator.portSE")}</option>
                                <option value={"(პორტი New Jersey)"}>{t("calculator.portNJ")}</option>
                            </select>
                        </div>
                        <div className='form-group mt-4'>
                            <label>{t("calculator.action")}</label>
                            <select className='form-control' value={priceForm.action} onChange={(e) => setPriceForm((prev) => ({...prev, action: e.target.value}))}>
                                <option value="">{t("calculator.selectAction")}</option>
                                <option value="plus">{t("calculator.plus")}</option>
                                <option value="minus">{t("calculator.minus")}</option>
                            </select>
                        </div>
                        <Modal.Footer>
                            <Button type='submit' variant={loadingCreateCalculators ? 'secondary' : 'primary'} disabled={loadingCreateCalculators}>{loadingCreateCalculators ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.save")}</Button>
                            <Button type='button' onClick={() => setPriceForm((prev) => ({...prev, show: false}))} variant='danger'>{t("common.close")}</Button>
                        </Modal.Footer>
                    </form>
                </Modal.Body>
            </Modal>
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{t("calculator.removeLocation")}</h3></Modal.Header>
                <Modal.Body><p>{t("calculator.confirmRemove")}</p></Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.deleteCalculators} variant={loadingCreateCalculators ? 'secondary' : 'primary'} disabled={loadingCreateCalculators}>{loadingCreateCalculators ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Calculators